import React 				from 'react';
import moment 				from 'moment';
import LazyComponent 		from '@Components/LazyComponent';

export const get_random_guid = () => {

	function s4 () {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
 
	return `${s4() + s4()}-${
		s4()}-${moment().toDate().getTime()}`;

};

export const getCurrencyName = (field) => {
	return field.toString() === '1' ? 'USD' : field.toString() === '2' ? 'EUR' : null;
};

export const getTimeRemaining = (endtime) => {
	let t = Date.parse(endtime) - Date.parse(new Date());
	let seconds = Math.floor((t / 1000) % 60);
	let minutes = Math.floor((t / 1000 / 60) % 60);
	let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	let days = Math.floor(t / (1000 * 60 * 60 * 24));
	return {
		total: t,
		days: days,
		hours: hours > 9 ? hours : '0'+hours,
		minutes: minutes > 9 ? minutes : '0'+minutes,
		seconds: seconds > 9 ? seconds : '0'+seconds,
	};
};

export const createAndDownloadBlobFile = (body, filename, extension = 'png', isAddMimeType = true) => {
	const fileName = `${filename}.${extension}`;
	const link = document.createElement('a');

	link.setAttribute('href', isAddMimeType ? `data:${body.mimetype};base64,${body.base64}` : body);
	link.setAttribute('download', fileName);
	link.style.visibility = 'hidden';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const _fileEncode = (arrayBuffer, mime_type) => {
	const b64encoded = btoa([].reduce.call(new Uint8Array(arrayBuffer), (p, c) => {
		return p+String.fromCharCode(c);
	}, ''));

	return {
		'mimetype': mime_type,
		'base64':   b64encoded,
	};
};

export const getQueryParamsInObj = (params = '', filterConfig = {}) => {
	/*
        возвращяем обьект со значениями из query параметров
        пример: {
            key: value,
        }
        @param { string } params -> query params
        @param { object } filterConfig
    */
	if (!params.length || !Object.values(filterConfig).length) return {};

	const arrayParams = params.slice(1).split('&');

	return arrayParams.reduce((obj, item) => {
		const [ key, value ] = item.split('=');

		return Object.keys(filterConfig).includes(key)
			? { ...obj, [ filterConfig[key] ]: value }
			: { ...obj }
	}, {});
};

export const checkDate = (date, format) => {
	const parsedDate = moment.utc(date);

	return parsedDate.isValid() ? parsedDate.format(format) : '-';
};

export const getDiffDates = (start, end, criterion) => {
	/**
     * Проверяем ДАТУ на валидность
     *
     * @param { date } start -> moment дата или new Date()
     * @param { date } end  -> moment дата или new Date()
     * @param { string } criterion -> moment параметр (hours, minutes, seconds)
     * @returns { number } -> пример 10
     */
	const startTime = moment(start);
	const endTime = moment(end);

	return +endTime.diff(startTime, criterion);
};

export const getInitialsByFullName = (name='', surname='') => {
	/**
     * Берем инициалы из имени и фамилии
     *
     * @param { string } name -> "Java"
     * @param { string } surname  -> "Script"
     * @returns { string } -> пример JS
     */

	return `${ name?.charAt(0)?.toUpperCase()}${ surname?.charAt(0)?.toUpperCase() }`
};

export const formatDate = (date, inputFormat, outputFormat) => {
	/**
     * Проверяем дату на inputFormat и возвращаем в outputFormat
     *
     * @param { obj } date -> moment дата
     * @param { string } inputFormat -> пример "YYYY-MM-DD"
     * @param { string } outputFormat -> пример "YYYY-MM-DD"
     * @returns { string } -> пример "YYYY-MM-DD"
     */
	return moment(date, inputFormat)?.isValid()
		? moment(date).format(outputFormat)
		: '';
}

/**
 * @param  { number | string } value
 * @return { string }
 */
export const replaceComma = value => String(value).replace(/,/, '.');

/**
  * @param  { number | string } value
  * @param  { number } dig
  * @return { string }
 */
export const floatNum = (value, dig = 2) => Number(value).toFixed(dig);

/**
  * @param  { func } fns
  * @return { string }
 */
export const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x);

/**
  * @param  { object } obj1
  * @param  { object } obj2
  * @return { object }
 */
// получение SHALLOW diff between objects
export const getDiffObjectValues = (obj1, obj2) => {
	let diffData = {};

	for (let key in obj1) {
		if (obj1[key] !== obj2[key]) {
			diffData = { ...diffData, [key]: obj1[key] }
		}
	}

	return diffData;
};

export const addFirstCharToValue = ({ value, char }) => {
	value = String(value);
	return (value.startsWith(char)) ? value : `${char}${value}`
}

/**
  * @param  { number | string } n
  * @return { boolean }
 */
export const roundFloat = (n) => {
	const nToNumber = (typeof n === 'number') ? n : Number(n);

	return nToNumber % 1 !== 0 ? n : nToNumber.toFixed()
};

export const generatePassword = () => {
	const length = 8 + Math.floor(Math.random() * (15 - 8 + 1)); // Длина пароля от 8 до 15 символов
	const groups = [
		'0123456789', // Цифры
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', // Буквы
		'!@#$%^&*();"\'_-.,', // Символы
	];
	
	// Выбираем 2 случайные группы из 3
	const selectedGroups = [];
	while (selectedGroups.length < 2) {
		const randomIndex = Math.floor(Math.random() * groups.length);
		if (!selectedGroups.includes(groups[randomIndex])) {
			selectedGroups.push(groups[randomIndex]);
		}
	}
	
	// Объединяем выбранные группы в один набор символов
	const charset = selectedGroups.join('');
	
	// Генерация пароля
	if (window.crypto && window.crypto.getRandomValues) {
		return Array(length)
			.fill(charset)
			.map(
				(x) =>
					x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * x.length)]
			)
			.join('');
	} else {
		let res = '';
		for (let i = 0, n = charset.length; i < length; ++i) {
			res += charset.charAt(Math.floor(Math.random() * n));
		}
		return res;
	}
};

export const saveToBuffer = (data) => {
	let textField = document.createElement('textarea');
	textField.innerText = data;
	document.body.appendChild(textField);
	textField.select();
	document.execCommand('copy');
	textField.remove();
}

export const get_random_number = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const lazyRender = (component) => {
	/**
     * Возвращаем компонент, обернутый в LazyComponent
     *
     * @param { component } component -> React компонент
     * @returns { strincomponentg } -> React компонент
     */
	return <LazyComponent>{ component }</LazyComponent>;
};

export const getDateWithTimezone = (
	date,
	timeZone = process.env.TIME_ZONE,
	locale='en-US'
) => {
	/**
     * @param  { string } date (example "2021-04-29T08:02:26.000000Z")
     * @param  { string } timeZone (example "America/New_York")
     * @return { string } (example "MM/DD/YYYY hh:mm:ss")
     */

	const options = {
		...(timeZone && { timeZone }),
		hour12: true,
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		// second: 'numeric',
	}

	const intlDate = new Intl.DateTimeFormat(locale, options);
	const isoDate = moment(date).toISOString();

	return intlDate.format(new Date(isoDate)).replace(',', '');
}


export const transformIsoDate = (date, format = 'YYYY.MM.DD', transformWithTimezone = false) => {
	const tzDate = transformWithTimezone ? getDateWithTimezone(date) : moment(date);

	// if (!moment(tzDate, "MM/DD/YYYY hh:mm:ss").isValid()) return "-";

	return date ? moment(tzDate).format(format) : '-';
}